import { useEffect, useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store';
import { useRouteHook, useTabs } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { AccountType } from '@shared/api';
import { StatementPaymentTab, StatementsCardTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const StatementsPage = () => {
  const { navigate } = useRouteHook();

  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const tabsState = useTabs();
  const { t } = useTranslation('statements');

  useEffect(() => {
    if (
      !profileFeatureStore.data?.statements?.viewOrDownloadAccountStatement &&
      !profileFeatureStore.data?.statements?.viewOrDownloadCardStatement &&
      !profileFeatureStore.data?.statements?.viewOrDownloadConsolidatedStatement
    )
      navigate(RoutePaths.dashboard.onNavigate());
  }, []);

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <StatementPaymentTab />;
    else if (tabsState.tab === AccountType.Card) return <StatementsCardTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')}>
      {!tabsState.loading && tabsState.hasCreditCard && tabsState.hasPayment && (
        <Tabs className='mb-6' options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
      )}
      {currentTabView}
    </PageContainer>
  );
};
